import { get } from 'lodash';
import * as UUID from 'uuid';
import { ApplicationConstants } from '../../app.constants';
import * as i0 from "@angular/core";
import * as i1 from "../../services/logging.service";
import * as i2 from "@angular/router";
import * as i3 from "@imaginelearning/web-api-core";
export class InitiateComponent {
    constructor(loggingService, activatedRoute, environment) {
        this.loggingService = loggingService;
        this.activatedRoute = activatedRoute;
        this.environment = environment;
    }
    ngOnInit() {
        const audience = this.environment.config.auth0Audience;
        const auth0RedirectUri = this.environment.config.auth0RedirectUri;
        const baseUrl = this.environment.config.auth0AuthorizeUrl;
        const clientId = this.environment.config.auth0ClientId;
        const state = UUID.v4() + 'T' + Date.now();
        this.loggingService.init(get(this.activatedRoute, 'snapshot.queryParams', {}));
        let scope = get(this.activatedRoute, 'snapshot.queryParams.scope');
        const connection = get(this.activatedRoute, 'snapshot.params.connection');
        if (!scope) {
            switch (connection) {
                case 'Clever':
                case 'clever':
                    scope = ApplicationConstants.cleverScope;
                    break;
                default:
                    scope = undefined;
                    break;
            }
        }
        const url = this.getAuthorizeUrl(baseUrl, clientId, connection, scope, audience, state, auth0RedirectUri);
        localStorage.setItem('ssoState', state);
        this.loggingService.warn(`InitiateController::activate: Initiating SSO login.`, {
            clientId,
            connection,
            scope,
            audience,
            baseUrl,
            redirectUrl: auth0RedirectUri
        });
        // Redirect to the authorize URL
        window.location.href = url;
    }
    getAuthorizeUrl(baseUrl, clientId, connection, scope, audience, state, redirectUrl) {
        var query = [];
        query.push('client_id=' + encodeURIComponent(clientId));
        query.push('connection=' + encodeURIComponent(connection));
        query.push('response_type=token%20id_token');
        query.push('scope=' + encodeURIComponent(scope));
        query.push('audience=' + encodeURIComponent(audience));
        query.push('state=' + encodeURIComponent(state));
        query.push('nonce=' + encodeURIComponent(state));
        query.push('redirect_uri=' + encodeURIComponent(redirectUrl));
        return baseUrl + (baseUrl.indexOf('?') < 0 ? '?' : '&') + query.join('&');
    }
    static { this.ɵfac = function InitiateComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || InitiateComponent)(i0.ɵɵdirectiveInject(i1.LoggingService), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i3.Environment)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InitiateComponent, selectors: [["initiate"]], decls: 0, vars: 0, template: function InitiateComponent_Template(rf, ctx) { }, encapsulation: 2 }); }
}
